"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.I18nEvent = void 0;
var I18nEvent;
(function (I18nEvent) {
    I18nEvent["MessagesChange"] = "MessagesChanged";
    I18nEvent["LocaleChange"] = "LocaleChange";
    I18nEvent["Change"] = "Change";
})(I18nEvent || (exports.I18nEvent = I18nEvent = {}));
//# sourceMappingURL=II18nManager.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/core/dist/services/II18nManager.js
// module id = 859
// module chunks = 0